import type { ManagerStreak } from '@/hooks/useManagerForms'
import { StreakIndicator } from '@/components/StreakIndicator'

export function FormIndicator({ form }: { form?: ManagerStreak }) {
  if (!form) return null
  return <StreakIndicator streak={form.streak} />
}
